import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Box } from '@mui/material'
import TextShadow from 'components/Text/TextShadow'
import PawButtton from 'components/Button/PawButtton'

const useStyles = makeStyles((theme) => ({
  marketBanner: {
    backgroundColor: '#2B1C2F',
    borderRadius: '8px',
    position: 'relative',
    overflow: 'hidden',
    marginTop: '24px',
    '& .bg': {
      width: '100%',
      position: 'relative',
      display: 'block',
      opacity: 0,
      zIndex: -1,
    },
    '& .character': {
      top: '0',
      right: '0',
      height: '100%',
      position: 'absolute',
      zIndex: 100,
    },
    '& .spinBG,.spinBGTop': {
      position: 'absolute',
      top: '-35%',
      right: '-20%',
      width: 'calc(100% * 1.4)',
      height: 'calc(100% * 1.4 * 1.4315)',
      backgroundSize: '100% 100%',
    },
    '& .spinBG': {
      backgroundImage: "url('/images/BG/radiant_orange.svg')",

      animationName: 'animate__spin__back',
      animationDuration: '15000ms',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
    },
    '& .spinBGTop': {
      backgroundImage: "url('/images/BG/radiant_yellow.svg')",
      animationName: 'animate__spin__back',
      animationDuration: '25000ms',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      zIndex: 101,
      opacity: 0.5,
    },
    '& .textBanner': {
      position: 'absolute',
      zIndex: 109,
      top: '2%',
      padding: '0',
      left: '2%',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    '& .centerButton': {
      position: 'absolute',
      zIndex: 110,
      bottom: '28%',
      width: '100%',
      textAlign: 'center',
      '& .MuiButton-root': {
        minWidth: '40%',
      },
    },
    '& .textBannerBottom': {
      position: 'absolute',
      zIndex: 109,
      bottom: '2%',
      padding: '0',
      width: '100%',
      textAlign: 'center',
    },
  },
  [theme.breakpoints.up('md')]: {
    marketBanner: {
      '& .textBanner': {
        transform: 'scale(0.75)',
        transformOrigin: 'bottom left',
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    marketBanner: {
      '& .textBanner': {
        transform: 'scale(1)',
      },
    },
  },
}))

const MarketBanner = () => {
  const classes = useStyles()
  return (
    <Box className={classes.marketBanner}>
      <Box className="textBanner">
        <TextShadow color="white" size="48" colorBorder="black" sizeBorder="4" lineHeight="60">
          Overhere! stranger...
        </TextShadow>
      </Box>
      <img className="bg" alt="character" src="/images/Prizes-Banner.png" />
      <img className="character" alt="character" src="/images/Samoyed-RE.png" />
      <Box className="spinBG" />
      <Box className="spinBGTop" />

      <Box className="centerButton">
        <PawButtton href="/marketplace" color="orange">
          MARKET
        </PawButtton>
      </Box>

      <Box className="textBannerBottom">
        <TextShadow color="white" size="24" colorBorder="black" sizeBorder="4" lineHeight="30">
          Welcome to SMOY NFT Marketplace.
        </TextShadow>
      </Box>
    </Box>
  )
}

export default MarketBanner
